import IconWallet1 from 'assets/icons/wallet-1.svg?react';
import IconWallet2 from 'assets/icons/wallet-2.svg?react';
import IconWallet3 from 'assets/icons/wallet-3.svg?react';
import IconWallet4 from 'assets/icons/wallet-4.svg?react';
import IconWallet5 from 'assets/icons/wallet-5.svg?react';
import IconWallet6 from 'assets/icons/wallet-6.svg?react';

export const items = [
  {
    icon: <IconWallet1 className="text-primary size-20" />,
    title: 'On-chain Limit & Range Orders',
  },
  {
    icon: <IconWallet2 className="text-primary size-20" />,
    title: 'Automated and Recurring strategies',
  },
  {
    icon: <IconWallet3 className="text-primary size-20" />,
    title: 'Easily Adjustable',
  },
  {
    icon: <IconWallet4 className="text-primary size-20" />,
    title: 'Rotating Liquidity',
  },
  {
    icon: <IconWallet5 className="text-primary size-20" />,
    title: 'All standard ERC-20 tokens',
  },
  {
    icon: <IconWallet6 className="text-primary size-20" />,
    title: 'MEV Resistant',
  },
];
